module.exports = __webpack_public_path__ + "media/images/tailwind/alumni-logo-ccd2876ccb76125286bf75d59645d5d7.png";